/**
 * Row-Model fuer SupplierInvoicesUploadModal.
 */
import type { CreateSupplierInvoiceRequest, ExpenseCategory } from '@/shared/api';
import { guessInvoice } from './akteUploadDefaults';

export interface SupplierInvoiceRow {
  id: string;
  file: File;
  supplier: string;
  invoiceNumber: string;
  amount: string;
  currency: string;
  issuedOn: string;
  dueOn: string;
  category: ExpenseCategory | '';
  notes: string;
  status: 'idle' | 'uploading' | 'done' | 'error';
  error: string | null;
}

export const EXPENSE_CATEGORIES: ExpenseCategory[] = [
  'Strom',
  'Gas',
  'Wasser',
  'Heizoel',
  'Internet',
  'Muell',
  'Versicherung',
  'Reparatur',
  'Reinigung',
  'Verwaltung',
  'GrundsteuerKommunal',
  'Zinsen',
  'Sonstiges',
];

export function newSupplierInvoiceRow(file: File, defaultCurrency: string): SupplierInvoiceRow {
  const guess = guessInvoice(file.name);
  return {
    id: `${file.name}-${file.size}-${file.lastModified}`,
    file,
    supplier: guess.supplier,
    invoiceNumber: '',
    amount: '',
    currency: defaultCurrency,
    issuedOn: guess.issuedOn || new Date().toISOString().slice(0, 10),
    dueOn: '',
    category: guess.category,
    notes: '',
    status: 'idle',
    error: null,
  };
}

export function isInvoiceRowValid(row: SupplierInvoiceRow): boolean {
  return (
    row.supplier.trim() !== '' &&
    row.amount.trim() !== '' &&
    !Number.isNaN(Number(row.amount.replace(',', '.'))) &&
    row.issuedOn !== '' &&
    row.category !== ''
  );
}

export function toCreateInvoiceRequest(row: SupplierInvoiceRow): CreateSupplierInvoiceRequest {
  return {
    supplier: row.supplier.trim(),
    invoiceNumber: row.invoiceNumber.trim() || null,
    amount: Number(row.amount.replace(',', '.')),
    currency: row.currency || 'EUR',
    issuedOn: row.issuedOn,
    dueOn: row.dueOn || null,
    periodFrom: null,
    periodTo: null,
    category: row.category as ExpenseCategory,
    relatedContractId: null,
    notes: row.notes.trim() || null,
  };
}
